module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "page-body"
  }, [(!_vm.fromOrderPage) ? _c('bar', {
    attrs: {
      "titleBar": _vm.titleBar
    },
    on: {
      "change": _vm.changeType
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('coupon-selection', {
    attrs: {
      "myAllCoupons": _vm.myCoupons,
      "comeFrom": _vm.fromOrderPage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7d77af4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyCoupons/MyCoupons.vue
// module id = 1706
// module chunks = 8